import { render, staticRenderFns } from "./EditFacadeModal.vue?vue&type=template&id=3043a3ad&lang=pug&"
import script from "./EditFacadeModal.vue?vue&type=script&lang=js&"
export * from "./EditFacadeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports